<app-leveltwo [pageName]="'Joint Tenancy Exclusion'">
    <div heading="General Info" class="General">
      <h3>{{'JointTenancy.SearchTitle'|translate}}</h3>

      <p>{{'JointTenancy.Ownership'|translate}}</p>

      <p>{{'JointTenancy.Priorto'|translate}}</p>
      <p><strong>{{'JointTenancy.JointTenancies'|translate}}</strong></p>
      <ol>
        <li>  {{'JointTenancy.UnityInterest'|translate}}</li>
        <li>  {{'JointTenancy.UnityTime'|translate}}</li>
        <li>  {{'JointTenancy.UnityPossession'|translate}}</li>
        <li>  {{'JointTenancy.UnityTitle'|translate}}</li>
      </ol>

      <p>{{'JointTenancy.Whenjoint'|translate}}</p>
      <p>{{'JointTenancy.Jointtenants'|translate}}</p>
      <p>{{'JointTenancy.Whenthe'|translate}}</p>
      <p>{{'JointTenancy.Jointtenancy'|translate}}</p>
      <p class="mb-0"><b>{{'JointTenancy.FilingReq'|translate}}</b></p>
      <p>{{'JointTenancy.Whenrecording'|translate}}</p>

    </div>

</app-leveltwo>
